import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import { environment } from '../../utils/environment/environment';
import { apiRequestErrorOccured, updateLoading } from '../slices/globalSlice';

const getDocuSignUrl = createAsyncThunk(
	'vjo/getDocusignUrl',
	async (data, { dispatch }) => {
		dispatch(updateLoading(true));
		try {
			const baseURL = environment.hcServiceBasePostUrl + `/getDocusignUrl`;
			const response = await axiosInstance.post(baseURL, data);
			return response.data;
		} catch (error) {
			return error;
		} finally {
			dispatch(updateLoading(false));
		}
	}
);

const checkDocuSignResponse = createAsyncThunk(
	'vjo/checkDocuSignResponse',
	async (data, { dispatch }) => {
		dispatch(updateLoading(true));
		try {
			const baseURL = environment.hcServiceBasePostUrl + `/checkDocuSignResponse`;
			const response = await axiosInstance.post(baseURL, data);
			dispatch(updateLoading(false));
			return response.data;
		} catch (error) {
			dispatch(apiRequestErrorOccured(error));
		}
	}
);

export { getDocuSignUrl, checkDocuSignResponse };
